// extracted by mini-css-extract-plugin
export default {"gallery":"c-q_fM","gallery__header":"c-q_fN","gallery__thumbs":"c-q_fO"};